import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import api from "../../services/api";
import { showError, showSuccess } from "../../services/alert";
import "./FluxoPlantio.css";
const etapas = [
  ["Dessecação", "Registre a dessecação inicial e a mistura utilizada."],
  ["Pré-emergente", "Registre a aplicação pré-emergente e todos os produtos."],
  ["Plantio", "Registre a implantação da cultura no talhão."],
  [
    "Pós-emergente + fungicida",
    "Aplicação prevista entre 25 e 30 dias após o plantio.",
  ],
  [
    "Fungicida · 1ª aplicação",
    "Primeira aplicação do ciclo, 13 dias após a anterior.",
  ],
  [
    "Fungicida · 2ª aplicação",
    "Segunda aplicação do ciclo, 13 dias após a anterior.",
  ],
  [
    "Fungicida · 3ª aplicação",
    "Terceira aplicação do ciclo, 13 dias após a anterior.",
  ],
  [
    "Fungicida · última aplicação",
    "Última aplicação do ciclo, 13 dias após a anterior.",
  ],
  [
    "Dessecação para colheita",
    "Registre a dessecação final antes da colheita.",
  ],
  ["Acompanhamento", "Ciclo de aplicações concluído."],
].map(([nome, descricao]) => ({ nome, descricao }));
const chave = "cultivamais.fluxo-plantio.avaliacao",
  hoje = () => new Date().toISOString().slice(0, 10),
  ler = () => {
    try {
      const dados = JSON.parse(localStorage.getItem(chave) || "[]");
      return (Array.isArray(dados) ? dados : [])
        .filter(
          (x) => Array.isArray(x.etapas) && Number.isInteger(x.etapaAtual),
        )
        .map((x) => ({
          ...x,
          historico: Array.isArray(x.historico) ? x.historico : [],
        }));
    } catch {
      return [];
    }
  };
export default function FluxoPlantio() {
  const [dados, setDados] = useState({ safras: [], talhoes: [], insumos: [] }),
    [fluxos, setFluxos] = useState(ler),
    [selecionado, setSelecionado] = useState(null),
    [inicio, setInicio] = useState({ safraId: "", talhaoId: "" }),
    [execucao, setExecucao] = useState({
      data: hoje(),
      responsavel: "",
      produtoId: "",
      quantidade: "",
      observacao: "",
    });
  useEffect(() => {
    Promise.all([api.get("/safras"), api.get("/talhoes"), api.get("/insumos")])
      .then(([s, t, i]) =>
        setDados({ safras: s.data, talhoes: t.data, insumos: i.data }),
      )
      .catch(() => showError("Não foi possível carregar os cadastros."));
  }, []);
  useEffect(() => {
    localStorage.setItem(chave, JSON.stringify(fluxos));
    window.dispatchEvent(new CustomEvent("cultivamais:lembretes-atualizados"));
  }, [fluxos]);
  useEffect(() => {
    if (!selecionado && fluxos[0]) setSelecionado(fluxos[0].id);
  }, [fluxos, selecionado]);
  const fluxo = fluxos.find((x) => x.id === selecionado) || fluxos[0],
    atual = fluxo ? etapas[fluxo.etapaAtual] : null;
  const criar = (e) => {
    e.preventDefault();
    if (
      fluxos.some(
        (x) => x.safraId === inicio.safraId && x.talhaoId === inicio.talhaoId,
      )
    )
      return showError("Já existe um fluxo para esta safra e talhão.");
    const s = dados.safras.find((x) => String(x.id) === inicio.safraId),
      t = dados.talhoes.find((x) => String(x.id) === inicio.talhaoId),
      n = {
        id: Date.now(),
        safraId: inicio.safraId,
        talhaoId: inicio.talhaoId,
        safra: s?.descricao || s?.cultura || `Safra ${inicio.safraId}`,
        talhao: t?.nome || "",
        etapaAtual: 0,
        etapas: [],
        historico: [`Fluxo iniciado em ${new Date().toLocaleString("pt-BR")}`],
      };
    setFluxos((v) => [n, ...v]);
    setSelecionado(n.id);
    showSuccess("Fluxo iniciado. Preparação liberada.");
  };
  const avançar = async (pular = false) => {
    if (!fluxo || !atual || (pular && !atual.opcional)) return;
    const exigeProduto = fluxo.etapaAtual !== 2 && fluxo.etapaAtual !== etapas.length - 1;
    const insumo = dados.insumos.find((x) => String(x.id) === String(execucao.produtoId));
    if (!pular && exigeProduto && !insumo) {
      showError("Selecione um produto cadastrado no estoque.");
      return;
    }
    if (!pular && exigeProduto && Number(execucao.quantidade) <= 0) {
      showError("Informe a quantidade utilizada.");
      return;
    }
    if (!pular && insumo && Number(insumo.estoqueAtual || 0) < Number(execucao.quantidade)) {
      showError(`Estoque insuficiente para ${insumo.nome}. Saldo disponível: ${insumo.estoqueAtual || 0}.`);
      return;
    }
    if (!pular && exigeProduto) {
      try {
        await api.post("/aplicacoesinsumo", {
          safraId: Number(fluxo.safraId),
          talhaoId: Number(fluxo.talhaoId),
          insumoId: Number(execucao.produtoId),
          quantidade: Number(execucao.quantidade),
          dataAplicacao: execucao.data,
          operador: execucao.responsavel || null,
          observacao: `${atual.nome}. ${execucao.observacao || ""}`.trim(),
        });
        setDados((estado) => ({
          ...estado,
          insumos: estado.insumos.map((item) =>
            String(item.id) === String(execucao.produtoId)
              ? { ...item, estoqueAtual: Number(item.estoqueAtual || 0) - Number(execucao.quantidade) }
              : item,
          ),
        }));
      } catch (error) {
        showError(error.response?.data?.message || "Não foi possível registrar a saída no estoque. A etapa não foi concluída.");
        return;
      }
    }
    const reg = {
        nome: atual.nome,
        status: pular ? "Ignorada" : "Concluída",
        ...execucao,
        produto: insumo?.nome || null,
        concluidaEm: new Date().toISOString(),
      },
      proxima = fluxo.etapaAtual + 1,
      dias = proxima === 3 ? 25 : proxima >= 4 && proxima <= 7 ? 13 : 0,
      dataBase = new Date(`${execucao.data}T12:00:00`);
    if (dias) dataBase.setDate(dataBase.getDate() + dias);
    const prevista = dias ? dataBase.toISOString().slice(0, 10) : null;
    setFluxos((v) =>
      v.map((x) =>
        x.id === fluxo.id
          ? {
              ...x,
              etapaAtual: proxima,
              dataPrevista: prevista,
              etapas: [...x.etapas, reg],
              historico: [
                ...x.historico,
                `${atual.nome} ${pular ? "ignorada" : "concluída"} em ${new Date().toLocaleString("pt-BR")}`,
              ],
            }
          : x,
      ),
    );
    setExecucao({
      data: prevista || hoje(),
      responsavel: "",
      produtoId: "",
      quantidade: "",
      observacao: "",
    });
    showSuccess(
      dias
        ? `Etapa concluída. Próxima aplicação calculada automaticamente para ${dataBase.toLocaleDateString("pt-BR")}.`
        : "Etapa concluída. Próxima etapa liberada automaticamente.",
    );
  };
  const progresso = fluxo
    ? Math.round((fluxo.etapaAtual / etapas.length) * 100)
    : 0;
  return (
    <div className="container mt-4 fluxo">
      <Header />
      <section className="fluxo-hero">
        <div>
          <small>CENTRAL OPERACIONAL</small>
          <h2>Plantio, preparações de solo e aplicações</h2>
          <p>Conclua a etapa atual para liberar automaticamente a próxima.</p>
        </div>
        <div className="fluxo-badge">
          <b>{fluxos.filter((x) => x.etapaAtual < etapas.length).length}</b>
          <span>fluxos ativos</span>
        </div>
      </section>
      <section className="fluxo-card">
        <div className="fluxo-card-title">
          <div>
            <h5>Iniciar fluxo de plantio</h5>
            <small>Um ciclo por safra e talhão.</small>
          </div>
          {fluxos.length > 0 && (
            <select
              className="seletor-fluxo"
              value={fluxo?.id || ""}
              onChange={(e) => setSelecionado(Number(e.target.value))}
            >
              {fluxos.map((x) => (
                <option key={x.id} value={x.id}>
                  {x.talhao} · {x.safra}
                </option>
              ))}
            </select>
          )}
        </div>
        <form className="row g-3 mt-1" onSubmit={criar}>
          <div className="col-md-5">
            <label>Safra</label>
            <select
              required
              value={inicio.safraId}
              onChange={(e) =>
                setInicio({ ...inicio, safraId: e.target.value })
              }
            >
              <option value="">Selecione a safra</option>
              {dados.safras.map((x) => (
                <option key={x.id} value={x.id}>
                  {x.descricao || x.cultura}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-5">
            <label>Talhão</label>
            <select
              required
              value={inicio.talhaoId}
              onChange={(e) =>
                setInicio({ ...inicio, talhaoId: e.target.value })
              }
            >
              <option value="">Selecione o talhão</option>
              {dados.talhoes.map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button className="btn btn-success w-100">Iniciar fluxo</button>
          </div>
        </form>
      </section>
      {fluxo && (
        <>
          <section className="fluxo-card">
            <div className="fluxo-resumo">
              <div>
                <small>FLUXO ATUAL</small>
                <h4>
                  {fluxo.talhao} · {fluxo.safra}
                </h4>
              </div>
              <b>{progresso}% concluído</b>
            </div>
            <div className="progresso">
              <i style={{ width: `${progresso}%` }} />
            </div>
            <div className="fluxo-etapas sequencial">
              {etapas.map((e, i) => {
                const reg = (fluxo.etapas || []).find((r) => r.nome === e.nome),
                  estado = reg
                    ? "concluida"
                    : i === fluxo.etapaAtual
                      ? "atual"
                      : "bloqueada";
                return (
                  <div className={estado} key={e.nome}>
                    <span>{reg ? "✓" : i + 1}</span>
                    <small>
                      {e.nome}
                      {e.opcional ? " · opcional" : ""}
                    </small>
                    {estado === "bloqueada" && (
                      <i className="bi bi-lock-fill" />
                    )}
                  </div>
                );
              })}
            </div>
          </section>
          <section className="fluxo-card etapa-card">
            {!atual ? (
              <div className="fluxo-finalizado">
                <i className="bi bi-check-circle-fill" />
                <h4>Fluxo concluído</h4>
                <p>O talhão está em acompanhamento contínuo.</p>
              </div>
            ) : (
              <>
                <div className="etapa-cabecalho">
                  <div>
                    <small>
                      ETAPA {fluxo.etapaAtual + 1} DE {etapas.length}
                    </small>
                    <h4>
                      {atual.nome}
                      {atual.opcional && <em>Opcional</em>}
                    </h4>
                    <p>{atual.descricao}</p>
                  </div>
                  <span className="etapa-atual">Etapa atual</span>
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label>Data</label>
                    <input
                      type="date"
                      value={execucao.data}
                      onChange={(e) =>
                        setExecucao({ ...execucao, data: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Responsável</label>
                    <input
                      value={execucao.responsavel}
                      onChange={(e) =>
                        setExecucao({
                          ...execucao,
                          responsavel: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Produto do estoque</label>
                    <select
                      value={execucao.produtoId}
                      onChange={(e) => setExecucao({ ...execucao, produtoId: e.target.value })}
                      disabled={fluxo.etapaAtual === 2 || fluxo.etapaAtual === etapas.length - 1}
                    >
                      <option value="">Selecione um produto cadastrado</option>
                      {dados.insumos.map((x) => (
                        <option key={x.id} value={x.id}>{x.nome} — saldo: {x.estoqueAtual ?? 0} {x.unidade || ''}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>Quantidade</label>
                    <input
                      type="number"
                      min="0"
                      step=".01"
                      value={execucao.quantidade}
                      onChange={(e) =>
                        setExecucao({ ...execucao, quantidade: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-8">
                    <label>Observação</label>
                    <input
                      value={execucao.observacao}
                      onChange={(e) =>
                        setExecucao({ ...execucao, observacao: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4 d-flex align-items-end gap-2">
                    {atual.opcional && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary flex-fill"
                        onClick={() => avançar(true)}
                      >
                        Pular etapa
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-success flex-fill"
                      onClick={() => avançar()}
                    >
                      Concluir e avançar
                    </button>
                  </div>
                </div>
              </>
            )}
          </section>
          <section className="fluxo-card">
            <h5>Histórico do fluxo</h5>
            {[...fluxo.historico].reverse().map((x, i) => (
              <div className="historico-item" key={i}>
                <i className="bi bi-check2-circle" />
                <span>{x}</span>
              </div>
            ))}
          </section>
        </>
      )}
    </div>
  );
}
